import {IBuilderComponentGroup, BuilderComponentSlug, IWidgetBuilderComponent, BuilderComponentGroupSlug} from "./types";

export enum builderComponentsStatus {
  visible = 'visible',
  hidden = 'hidden',
}

export interface IBuilderComponentsStatus {
  slug: BuilderComponentSlug,
  status: builderComponentsStatus | null,
}

export const builderComponentsStatuses: IBuilderComponentsStatus[] = [];

export const menuScrollAnimationTime: number = 500;

export const setAllBuilderComponentStatuses = (builderComponentGroups: IBuilderComponentGroup[]) => {
  builderComponentGroups.forEach((builderComponentGroup: IBuilderComponentGroup) => {
    builderComponentGroup.widgetBuilderComponent.forEach((widgetBuilderComponent: IWidgetBuilderComponent) => {

      // Skip Google Ads Components
      if (BuilderComponentSlug.adBanner !== widgetBuilderComponent.builderComponent.slug) {
        builderComponentsStatuses.push({
          slug: widgetBuilderComponent.builderComponent.slug,
          status: null,
        });
      }

    })
  })
}

export const getInitialActiveBuilderComponentGroupSlug = (builderComponentGroups: IBuilderComponentGroup[]): BuilderComponentGroupSlug => {
  const notEmptyBuilderComponentGroups = builderComponentGroups.filter((builderComponentGroup: IBuilderComponentGroup) => builderComponentGroup.widgetBuilderComponent.length > 0)
  return notEmptyBuilderComponentGroups.length > 0 ? notEmptyBuilderComponentGroups[0].slug : BuilderComponentGroupSlug.overview;
}
